import React from 'react'
import Label from '../../../Form/Label';

const VideoSection = ({
    formData,
    setFormData,

    sampleGuide,
    videoWarning,
    setVideoWarning
   
}) => {
  return (
    <main className="flex w-full justify-between gap-6">
       <div className="bg-white h-fit  flex flex-col gap-3 rounded-[10px] p-[30px] w-[42%]">
        <div className="text-customGreen  text-[17px] mb-4 font-semibold">
          Section Layout
        </div>
        <img
          src={sampleGuide.video}
          className="w-full"
          alt="Header and Hero Preview"
        />
      </div>
      <div className="bg-white overflow-x-auto min-h-72 rounded-[10px] p-[30px] flex-1">
        <div className="flex items-center justify-between flex-1 mb-8">
          <div className="text-customGreen text-[17px] font-semibold  ">
          Customer Testimonial Section
          </div>

          <div className="flex ">
            <label className="inline-flex mb-5 cursor-pointer">
            
            <input
                              type="checkbox"
                              checked={formData.videoSection.enable}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  videoSection: {
                                    ...formData.videoSection,
                                    enable: e.target.checked,
                                  },
                                })
                              }
                              className="sr-only peer"
                            />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                    
          </div>
        </div>
                    <div className="flex flex-col gap-3">
                      {/* <div className="flex  justify-between gap-2">
                        <Label label={"Enable This Section"} />
        
                        <div class="flex  w-[75%]">
                          <label class="inline-flex  mb-5 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={formData.videoSection.enable}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  videoSection: {
                                    ...formData.videoSection,
                                    enable: e.target.checked,
                                  },
                                })
                              }
                              className="sr-only peer"
                            />
                            <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                          </label>
                        </div>
                      </div> */}
        
                      <div className="flex  justify-between gap-2 ">
                        <Label label={"Section Title"} />
        
                        <div class="flex items-center justify-center w-[75%]">
                          <input
                            type="text"
                            value={formData.videoSection.title}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                videoSection: {
                                  ...formData.videoSection,
                                  title: e.target.value,
                                },
                              })
                            }
                            maxLength={50}
                            placeholder="Enter Title"
                            class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                          />
                        </div>
                      </div>
        
                      <div className="flex justify-between gap-2">
                        <Label label={"Video Link"} />
        
                        <div className="flex flex-col gap-1 w-[75%] relative">
                          <div className="flex items-center justify-center w-full">
                            <input
                              type="text"
                              value={formData.videoSection.videoLink}
                              onChange={(e) => {
                                const value = e.target.value;
                                const youtubeRegex =
                                  /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/).+/;
        
                                if (value === "" || youtubeRegex.test(value)) {
                                  setFormData({
                                    ...formData,
                                    videoSection: {
                                      ...formData.videoSection,
                                      videoLink: value,
                                    },
                                  });
                                  setVideoWarning(false);
                                } else {
                                  setVideoWarning(true);
                                  setTimeout(() => {
                                    setVideoWarning(false);
                                  }, 2000);
                                }
                              }}
                              placeholder="Paste the YouTube video link"
                              className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                            />
                          </div>
        
                          {videoWarning && (
                            <div className="absolute top-full left-0 mt-1 bg-red-500 text-white text-xs px-3 py-1 rounded shadow z-10 w-max">
                              Paste the YouTube video link
                            </div>
                          )}
                        </div>
                      </div>
        
                      <div className="flex  justify-between gap-2 ">
                        <Label label={"Section Description"} />
        
                        <div class="flex items-center justify-center w-[75%]">
                          <input
                            type="text"
                            value={formData.videoSection.description}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                videoSection: {
                                  ...formData.videoSection,
                                  description: e.target.value,
                                },
                              })
                            }
                            maxLength={120}
                            placeholder="Enter Section Description"
                            class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
    </main>
  )
}

export default VideoSection